<ph-field>
    <ph-toolbar justify="between" nowrap>
        <ph-label>{{ section.label }}</ph-label>
        <ph-badge *ngIf="confidenceLabel as label" class="ap-confidence-badge" variant="light" [color]="confidenceColor">{{ label }}</ph-badge>
    </ph-toolbar>
    <ph-select
        [items]="items"
        [value]="value"
        [ariaLabel]="section.label"
        (ph-change)="onSelectionChange($event.detail)">
    </ph-select>
    <ph-hint *ngIf="section.hint as hint">{{ hint }}</ph-hint>
    <ph-hint *ngIf="effectPrefix && selectedLabel as label">{{ effectPrefix }} {{ label }}</ph-hint>
</ph-field>
